import { DialogComponent } from '@theme/dialog';

/**
 * A dialog that lazily fetches and injects the full rendered content of the
 * linked page's template (not just `page.content`) the first time it opens.
 */
export class PopupLinkComponent extends DialogComponent {
  /** @type {Promise<void> | null} */
  #loadPromise = null;

  showDialog() {
    super.showDialog();
    this.#loadPageContent();
  }

  #loadPageContent() {
    if (this.#loadPromise) return;

    const url = this.dataset.pageUrl;
    const container = this.querySelector('[data-popup-link-page-content]');

    if (!url || !container) return;

    this.#loadPromise = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to fetch page: HTTP error ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const pageContent = html.getElementById('MainContent');

        if (pageContent) container.innerHTML = pageContent.innerHTML;
      })
      .catch((error) => {
        console.error(error);
        this.#loadPromise = null;
      });
  }
}

if (!customElements.get('popup-link-component')) {
  customElements.define('popup-link-component', PopupLinkComponent);
}
